<template>
  <section class="schedule" id="schedule">
    <div class="container">
      <div class="schedule-grid">
        <!-- Left Column: Title & Description -->
        <div class="schedule-desc wow slideInLeft">
          <h2>Otváracie Hodiny</h2>
          <p>
            Vitajte v našom fitnes centre! Radi by sme vám poskytli informácie o
            našich otváracích hodinách, aby ste vedeli, kedy sme k dispozícii.
            Naše otváracie hodiny sú prispôsobené vašim potrebám, aby ste mohli
            trénovať vo vhodnom čase. Tešíme sa na vašu návštevu!
          </p>
          <p class="note">
            <i class="fa fa-info-circle"></i>
            Otváracie hodiny počas sviatkov môžu byť iné ako uvedené.
          </p>
        </div>

        <!-- Right Column: Image & Table -->
        <div class="schedule-right wow slideInRight">
          <div class="hours-wrapper">
            <div class="gym-img">
              <img src="@/assets/images/diamond_pohlad_na_recepciu.jpg" alt="Recepcia Diamond Gym" />
            </div>
            <div class="table-wrapper">
              <table class="schedule-table">
                <thead>
                  <tr>
                    <th>Deň</th>
                    <th colspan="2">Hodiny</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in schedule" :key="row.day">
                    <td class="day">{{ row.day }}</td>
                    <td>{{ row.from }}</td>
                    <td>{{ row.to }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ScheduleSection",
  data() {
    return {
      schedule: [
        { day: 'Pondelok', from: '6:00', to: '22:00' },
        { day: 'Utorok',   from: '6:00', to: '22:00' },
        { day: 'Streda',   from: '6:00', to: '22:00' },
        { day: 'Štvrtok',  from: '6:00', to: '22:00' },
        { day: 'Piatok',   from: '6:00', to: '22:00' },
        { day: 'Sobota',   from: '8:00', to: '21:00' },
        { day: 'Nedeľa',   from: '8:00', to: '21:00' },
      ]
    }
  }
}
</script>

<style scoped>
.schedule {
  background: #0d0d0d;
  color: #fff;
}

.schedule-grid {
  display: flex;
  gap: 48px;
  align-items: flex-start;
}

/* Left column */
.schedule-desc {
  flex: 1 1 38%;
}

.schedule-desc h2 {
  font-size: clamp(24px, 3.5vw, 34px);
  color: #E8B923;
  margin-bottom: 16px;
}

.schedule-desc h2::after {
  content: '';
  display: block;
  width: 48px;
  height: 3px;
  background: #E8B923;
  border-radius: 2px;
  margin-top: 10px;
  margin-bottom: 20px;
}

.schedule-desc p {
  font-size: 15px;
  line-height: 1.75;
  color: #bbb;
  margin-bottom: 16px;
}

.note {
  font-size: 13px !important;
  color: #888 !important;
  font-style: italic;
}

.note .fa {
  color: #E8B923;
  margin-right: 6px;
}

/* Right column */
.schedule-right {
  flex: 1 1 58%;
}

.hours-wrapper {
  display: flex;
  gap: 20px;
  align-items: stretch;
  height: 380px;
}

.gym-img {
  flex: 1;
  border-radius: 12px;
  overflow: hidden;
}

.gym-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.table-wrapper {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.schedule-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.schedule-table thead th {
  background: #E8B923;
  color: #000;
  padding: 10px 14px;
  font-weight: 700;
  text-align: center;
  font-size: 13px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.schedule-table thead th:first-child {
  border-radius: 8px 0 0 0;
}

.schedule-table thead th:last-child {
  border-radius: 0 8px 0 0;
}

.schedule-table tbody tr {
  transition: background-color 0.2s ease;
}

.schedule-table tbody tr:hover {
  background-color: #1e1e1e;
}

.schedule-table td {
  border-bottom: 1px solid #222;
  padding: 11px 14px;
  text-align: center;
  color: #ccc;
}

.schedule-table .day {
  font-weight: 600;
  color: #fff;
  background: #191919;
  text-align: left;
  padding-left: 16px;
}

/* Tablet */
@media (max-width: 900px) {
  .schedule-grid {
    flex-direction: column;
    gap: 32px;
  }

  .schedule-desc,
  .schedule-right {
    flex: 1 1 100%;
  }

  .hours-wrapper {
    height: auto;
    gap: 16px;
  }

  .gym-img {
    aspect-ratio: 16 / 7;
    height: auto;
  }

  .gym-img img {
    width: 100%;
    height: 100%;
  }

  .table-wrapper {
    justify-content: stretch;
  }
}

/* Mobile */
@media (max-width: 540px) {
  .hours-wrapper {
    flex-direction: column;
  }

  .gym-img {
    aspect-ratio: 16 / 9;
  }

  .schedule-table {
    font-size: 13px;
  }

  .schedule-table td {
    padding: 9px 10px;
  }
}
</style>
